import { IPrivacyPolicy } from '../_types/privacy-policy';

export const PRIVACY_POLICY_V1: IPrivacyPolicy[] = [
  {
    main_title:
      'KEBIJAKAN PRIVASI PENGGUNA MARKETPLACE HEALTHY ONE B2C VERSI 1.0.0',
    description: `Selamat datang di Platform Healthy One! Kebijakan privasi ini ("Kebijakan Privasi") menjelaskan bagaimana ketentuan Healthy One ("Kami") dalam memperoleh, mengumpulkan, menyimpan, menguasai, menggunakan, mengolah, menganalisa, memperbaiki, melakukan pembaruan, menampilkan, mengumumkan, mentransfer, mengungkapkan dan melindungi ("Pemrosesan") Data Pribadi yang Anda berikan melalui Platform Healthy One ("Platform"). Dengan menggunakan Platform Kami, Anda dianggap telah membaca, memahami, dan menyetujui untuk terikat dengan ketentuan-ketentuan dalam Kebijakan Privasi ini. Kebijakan Privasi ini merupakan bagian yang tidak terpisahkan dari Syarat dan Ketentuan Kami. Penggunaan istilah-istilah dalam huruf kapital dalam Kebijakan Privasi ini memiliki arti sesuai yang didefinisikan dan digunakan dalam Syarat dan Ketentuan, kecuali dinyatakan lain dalam Kebijakan Privasi ini. Semua referensi untuk "Anda" dalam Kebijakan Privasi merujuk kepada subjek data yaitu Pengguna. Kebijakan Privasi ini berlaku untuk semua layanan yang disediakan oleh Kami melalui Platform.`,
    sub_description: `Harap membaca dengan seksama sebelum Anda mengakses, mendaftar dan/atau menggunakan Platform Kami.`,
    chapter: [
      {
        header: 'A. Persetujuan',
        content: [
          {
            content: (
              <ol className="list-decimal pl-10 text-justify leading-8">
                <li>
                  Dengan menggunakan Platform Kami, Anda dianggap telah membaca,
                  memahami, dan menyetujui untuk terikat dengan
                  ketentuan-ketentuan dalam Kebijakan Privasi ini. Anda setuju
                  dan memberikan persetujuan eksplisit Anda kepada Kami untuk
                  melakukan Pemrosesan Data Pribadi Anda sesuai dengan Kebijakan
                  Privasi ini.
                </li>
                <li>
                  Anda wajib memberikan informasi pribadi Anda dengan akurat,
                  milik Anda, dan harus memperbarui data apabila terdapat
                  perubahan. Anda dengan ini membebaskan Kami dari setiap
                  tuntutan, gugatan, ganti rugi, dan/atau klaim sehubungan
                  dengan kelalaian Anda terhadap kebenaran setiap informasi
                  terhadap Data Pribadi yang Anda berikan menjadi tanggung jawab
                  sepenuhnya dari Anda.
                </li>
                <li>
                  Anda bertanggung jawab penuh untuk menjaga kerahasiaan Data
                  Pribadi Anda dan Kami tidak bertanggung jawab terhadap data
                  yang diungkapkan dan disebarluaskan Anda baik secara sengaja
                  ataupun tidak sengaja.
                </li>
              </ol>
            ),
          },
        ],
      },
      {
        header: 'B. Data Pribadi',
        content: [
          {
            content: (
              <>
                <p className="mb-4 pl-5 text-justify leading-8">
                  "Data Pribadi" merujuk pada informasi, data, atau keterangan
                  dalam bentuk apa pun yang dapat mengidentifikasi Anda, yang
                  Anda sampaikan atau berikan kepada Kami dan Anda cantumkan
                  melalui Platform terkait informasi mengenai diri Anda. Data
                  Pribadi tidak termasuk pada setiap informasi yang telah
                  tersedia dalam domain publik.
                </p>
                <p className="mb-4 pl-5 text-justify leading-8">
                  Data Pribadi yang dikumpulkan saat Anda menggunakan Platform
                  mengandung jenis Data Pribadi meliputi:
                </p>
                <ol className="list-decimal pl-10 text-justify leading-8">
                  <li>
                    Identitas, yang meliputi nama, tanggal lahir, alamat, jenis
                    kelamin, nomor telepon, alamat email, nama Pengguna, dan
                    setiap foto yang Anda unggah dalam Platform.
                  </li>
                  <li>
                    Data Transaksi, yang meliputi rincian rekening bank, rincian
                    kartu kredit, rincian Produk dan layanan yang Anda berikan
                    atau dapatkan dari Platform, riwayat transaksi, alamat
                    pengiriman, pembayaran pesanan dari dan kepada Anda.
                  </li>
                  <li>
                    Informasi Anda terhadap akses penggunaan ke Platform, yang
                    meliputi konten dan Produk apa saja yang Anda lihat, fitur
                    layanan yang Anda akses, dan statistik serupa yang lain.
                  </li>
                  <li>
                    Informasi kesehatan Anda, termasuk namun tidak terbatas pada
                    riwayat medis, kondisi kesehatan, laporan, resep, alergi,
                    diagnosis, dan informasi medis lainnya.
                  </li>
                  <li>
                    Informasi perangkat Anda, termasuk namun tidak terbatas pada
                    alamat Internet Protocol (IP), lokasi Anda, koordinat Global
                    Positioning System (GPS), nomor International Mobile
                    Equipment Identity (IMEI).
                  </li>
                  <li>
                    Jika Anda merupakan Penjual, pengumpulan dapat meliputi
                    termasuk namun tidak terbatas pada nama perusahaan, alamat,
                    informasi usaha, informasi direktur dan pemegang saham,
                    informasi pajak, akta, Nomor Induk Berusaha (NIB), Nomor
                    Pokok Wajib Pajak (NPWP), Surat Izin Praktek (SIP), Surat
                    Tanda Registrasi (STR), Surat Izin Praktik Apoteker (SIPA),
                    Surat Izin Apotek (SIA), Izin Operasional.
                  </li>
                  <li>Lokasi pada status pengiriman atau penerimaan Produk.</li>
                  <li>
                    Korespondensi, yang meliputi obrolan dalam Platform, ulasan,
                    riwayat, tanggapan.
                  </li>
                </ol>
              </>
            ),
          },
        ],
      },
      {
        header: 'C. Pengumpulan Data Pribadi',
        content: [
          {
            content: (
              <ol className="list-decimal pl-10 text-justify leading-8">
                <li>
                  Anda setuju memberikan Data Pribadi yang akurat, tidak
                  menyesatkan, dan terkini. Anda dapat memberitahukan kepada
                  Kami terhadap setiap perubahan Data Pribadi tersebut. Kami
                  berhak melakukan verifikasi terhadap Data Pribadi yang Anda
                  berikan melalui Platform sebagai bagian dari Kami dalam
                  melakukan proses verifikasi Pengguna Platform.
                </li>
                <li>
                  Jika Anda tidak memberikan Data Pribadi Anda, maka Kami tidak
                  dapat memberikan layanan atau fitur kepada Anda secara normal
                  atau memberikan akses pada Platform.
                </li>
                <li>
                  Data Pribadi dikumpulkan pada saat Anda menggunakan Platform
                  dan layanan yang disediakan melalui Platform pada saat sebagai
                  berikut:
                  <ol className="mt-2 list-[lower-alpha] pl-5">
                    <li>Membuat dan mendaftarkan akun sebagai Pengguna;</li>
                    <li>Mengakses dan menjelajahi Platform;</li>
                    <li>
                      Menggunakan layanan atau fitur yang tersedia dalam
                      Platform;
                    </li>
                    <li>
                      Jika Anda merupakan Penjual, pada saat Anda mencantumkan
                      Produk yang dijual melalui Platform dan sehubungan dengan
                      Transaksi;
                    </li>
                    <li>
                      Jika Anda merupakan Pembeli, pada saat Anda melakukan
                      Transaksi pembelian Produk;
                    </li>
                    <li>
                      Melakukan aktivitas sehubungan dengan pembayaran dalam
                      Platform;
                    </li>
                    <li>Mengunggah suatu konten dalam Platform;</li>
                    <li>Melakukan obrolan melalui Platform;</li>
                    <li>Berinteraksi dengan Kami melalui Platform;</li>
                    <li>
                      Keluhan yang diajukan oleh pihak ketiga terhadap Anda.
                    </li>
                  </ol>
                </li>
              </ol>
            ),
          },
        ],
      },
      {
        header: 'D. Penggunaan Data Pribadi',
        content: [
          {
            content: (
              <ol className="list-decimal pl-10 text-justify leading-8">
                <li>
                  Data Pribadi yang Anda berikan dapat digunakan oleh kami untuk
                  tujuan berikut ini:
                  <ol className="mt-2 list-[lower-alpha] pl-5">
                    <li>
                      Mengidentifikasi dan mendaftarkan Anda sebagai Pengguna;
                    </li>
                    <li>
                      Memberikan izin kepada Anda untuk mengakses layanan dan
                      fitur-fitur dalam Platform;
                    </li>
                    <li>
                      Memberikan fasilitas terhadap Transaksi dan pembayaran
                      Anda;
                    </li>
                    <li>
                      Menyediakan layanan yang Anda minta melalui Platform;
                    </li>
                    <li>Melakukan kepatuhan internal Platform dan Kami;</li>
                    <li>Melakukan kepatuhan terhadap hukum yang berlaku;</li>
                    <li>
                      Melakukan peninjauan dan memantau aktivitas Anda melalui
                      Platform;
                    </li>
                    <li>
                      Melakukan verifikasi dan melindungi dari aktivitas yang
                      dilarang, berbahaya, ilegal, curang dan/atau melanggar
                      ketentuan hukum dan peraturan perundang-undangan yang
                      berlaku;
                    </li>
                    <li>Memproses pesanan Anda melalui Platform;</li>
                    <li>Memberikan informasi terhadap pengiriman Produk;</li>
                    <li>
                      Melakukan arsip terhadap informasi apa pun yang diminta
                      oleh pemerintah, instansi yang berwenang, otoritas
                      dan/atau hukum;
                    </li>
                    <li>
                      Memungkinkan sejauh yang diperlukan oleh hukum dalam
                      mematuhi kewajiban hukum, menanggapi permintaan,
                      penyelidikan, atau arahan dari otoritas yang berwenang;
                    </li>
                    <li>
                      Memenuhi permintaan yang wajar terhadap ketentuan layanan
                      pihak ketiga;
                    </li>
                    <li>
                      Memberikan penawaran kepada Anda terhadap Layanan yang
                      terhubung melalui kerja sama dengan pihak ketiga;
                    </li>
                    <li>
                      Tujuan lain yang diwajibkan atau disahkan oleh hukum.
                    </li>
                  </ol>
                </li>
                <li>
                  Kami dapat mengungkapkan Data Pribadi Anda kepada afiliasi
                  dan/atau pihak lain untuk tujuan berikut:
                  <ol className="mt-2 list-[lower-alpha] pl-5">
                    <li>
                      Kepentingan investigasi internal, proses hukum, atau
                      keadaan darurat terkait keselamatan;
                    </li>
                    <li>
                      Untuk mematuhi peraturan perundang-undangan, termasuk
                      menanggapi permintaan, penyelidikan, atau arahan dari
                      otoritas pemerintah yang berwenang;
                    </li>
                    <li>
                      Kepada penyedia layanan pihak ketiga (vendor, pemasok,
                      kontraktor, atau mitra) yang membantu Kami dalam
                      menyediakan layanan di Platform, seperti penyedia layanan
                      pembayaran dan logistik;
                    </li>
                    <li>
                      Jika Kami membagikan Data Pribadi kepada anak perusahaan
                      Kami atau afiliasi Kami atau Mitra Kami, Kami melakukannya
                      agar pihak-pihak terkait dapat membantu Kami dalam
                      menyediakan dan mengelola layanan, termasuk jika Anda
                      berlangganan daftar e-mail Kami untuk tujuan pemasaran.
                      Mereka juga dapat memproses data atas nama Kami untuk
                      mendukung layanan Kami dan grup perusahaan Kami, melakukan
                      penelitian dan pengembangan guna meningkatkan layanan,
                      mencegah penyalahgunaan, serta memberikan dukungan kepada
                      Pengguna;
                    </li>
                    <li>
                      Terkait dengan penggabungan, akuisisi, atau
                      restrukturisasi bisnis;
                    </li>
                    <li>
                      Memberikan fasilitas kinerja dan pelayanan untuk Anda
                      dengan pihak lain.
                    </li>
                  </ol>
                </li>
                <li>
                  Jika Anda adalah Penjual, Anda akan mengakses dan memproses
                  Data Pribadi serta data kesehatan Pembeli untuk tujuan khusus
                  sebagaimana diatur berikut:
                  <ol className="mt-2 list-[lower-alpha] pl-5">
                    <li>
                      Akses ke Rekam Medis Elektronik (RME), sebagai berikut:
                      <ol className="mt-2 pl-3">
                        <li>
                          1) Data Pribadi Pembeli yang mengandung data kesehatan
                          yang tidak dibuat untuk dapat diakses oleh publik,
                          termasuk namun tidak terbatas pada resep, riwayat
                          medis, dan ringkasan medis, tidak akan dibagikan
                          kepada pihak mana pun, kecuali kepada Anda dan mitra
                          yang dipilih untuk berkonsultasi melalui Platform;
                        </li>
                        <li>
                          2) Dengan persetujuan eksplisit Pembeli, Kami dapat
                          memfasilitasi akses mitra lain di Platform terhadap
                          Rekam Medis Elektronik Pembeli untuk tujuan
                          kesinambungan perawatan dan pelayanan kesehatan yang
                          lebih terintegrasi.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Integrasi SATUSEHAT dan BPJS Kesehatan, Kami merupakan
                      penyedia Layanan melalui Platform yang terintegrasi dengan
                      ekosistem kesehatan nasional dengan ketentuan sebagai
                      berikut:
                      <ol className="mt-2 pl-3">
                        <li>
                          1) Rekam Medis Elektronik akan diintegrasi ke dalam
                          sistem SATUSEHAT untuk tujuan pelaporan data medis ke
                          Kementerian Kesehatan;
                        </li>
                        <li>
                          2) Rekam Medis Elektronik akan diintegrasi ke dalam
                          sistem BPJS Kesehatan untuk tujuan verifikasi
                          kepesertaan, pengajuan klaim, dan pelayanan kesehatan
                          terpadu khusus bagi fasilitas kesehatan yang bekerja
                          sama dengan BPJS Kesehatan.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li>
                  Kami menjamin bahwa Data Pribadi Anda yang diungkapkan kepada
                  afiliasi dan/atau pihak lain adalah sesuai dengan tujuan yang
                  tercantum dalam Kebijakan Privasi ini dan/atau sesuai
                  peraturan perundang-undangan yang berlaku.
                </li>
              </ol>
            ),
          },
        ],
      },
      {
        header: 'E. Penyimpanan dan Keamanan Data Pribadi',
        content: [
          {
            content: (
              <ol className="list-decimal pl-10 text-justify leading-8">
                <li>
                  Kami telah memiliki sertifikasi standar keamanan yang relevan
                  untuk memastikan keamanan Data Pribadi Anda.
                </li>
                <li>
                  Kami akan menyimpan Data Pribadi Anda selama diwajibkan atau
                  sepanjang diizinkan oleh hukum atau selama menyediakan layanan
                  Kami dan relevan dengan tujuan dalam Kebijakan Privasi ini.
                </li>
                <li>
                  Data Pribadi Anda akan disimpan dan secara aman pada pusat
                  data Kami di Indonesia, termasuk oleh afiliasi dan pihak lain
                  untuk penyediaan layanan kepada Anda sesuai dengan prinsip
                  perlindungan data pribadi sebagaimana dengan Undang-Undang
                  Nomor 27 Tahun 2022 beserta peraturan pelaksananya dan
                  peraturan terkait lainnya yang berlaku di Republik Indonesia.
                </li>
                <li>
                  Dalam hal terjadi penggabungan, pengambilalihan, peleburan,
                  pemisahan, pembubaran yang menyebabkan terjadinya transfer
                  Data Pribadi Anda, Kami akan memberitahu Anda sebelum transfer
                  Data Pribadi dilakukan dan memberitahukan pengendali Data
                  Pribadi berikutnya.
                </li>
                <li>
                  Kami akan menerapkan upaya terbaik secara teknis dan
                  operasional untuk melindungi dan mengamankan Data Pribadi Anda
                  dari setiap akses, pengumpulan, atau pengungkapan yang tidak
                  berwenang.
                </li>
                <li>
                  Anda menyetujui bahwa Kami tidak dapat menjamin bahwa Data
                  Pribadi apa pun yang Anda kirimkan melalui internet tidak akan
                  diakses, diungkapkan, diubah, atau dimusnahkan oleh pihak
                  ketiga yang tidak berwenang karena faktor di luar kendali
                  Kami.
                </li>
                <li>
                  Selain upaya terbaik yang selalu Kami lakukan untuk melindungi
                  Data Pribadi Anda, Anda bertanggung jawab untuk menjaga
                  kerahasiaan dan keamanan dari setiap rincian akun Anda,
                  termasuk Anda wajib untuk tidak memberikan akses akun Anda
                  kepada siapa pun dan bertanggung jawab terhadap keamanan
                  perangkat yang Anda gunakan.
                </li>
              </ol>
            ),
          },
        ],
      },
      {
        header: 'F. Hak Anda',
        content: [
          {
            content: (
              <ol className="list-decimal pl-10 text-justify leading-8">
                <li>
                  Anda berhak untuk melengkapi, memperbaiki, atau memperbarui
                  Data Pribadi Anda yang terdapat dalam Platform kapan saja
                  melalui Platform atau dengan menghubungi Kami.
                </li>
                <li>
                  Anda dapat meminta informasi tentang Pemrosesan Data Pribadi
                  Anda, mendapatkan akses, dan memperoleh salinan Data Pribadi.
                </li>
                <li>
                  Anda dapat menarik kembali persetujuan Anda terhadap
                  Pemrosesan Data Pribadi atau meminta penghapusan Data Pribadi
                  Anda kapan saja dengan memberikan pemberitahuan secara
                  tertulis kepada Kami melalui kontak yang tersedia dalam
                  Kebijakan Privasi ini. Penarikan kembali persetujuan yang Anda
                  lakukan mengakibatkan Kami melakukan penghentian layanan
                  dengan melakukan penghapusan akun Anda.
                </li>
              </ol>
            ),
          },
        ],
      },
      {
        header: 'G. Hukum Yang Mengatur',
        content: [
          {
            content: (
              <p className="pl-5 text-justify leading-8">
                Kebijakan Privasi ini diatur berdasarkan hukum Negara Republik
                Indonesia dan tunduk pada peraturan perundang-undangan terkait
                perlindungan data pribadi beserta peraturan pelaksana dan
                peraturan terkait lainnya yang berlaku.
              </p>
            ),
          },
        ],
      },
      {
        header: 'H. Pembaruan Kebijakan Privasi',
        content: [
          {
            content: (
              <p className="pl-5 text-justify leading-8">
                Kami berhak untuk mengubah atau memperbarui Kebijakan Privasi
                ini sewaktu waktu tanpa adanya pemberitahuan terlebih dahulu.
                Perubahan akan berlaku efektif setelah diumumkan di Platform.
                Dengan terus menggunakan Platform, maka Anda dianggap telah
                menyetujui setiap perubahan dalam Kebijakan Privasi.
              </p>
            ),
          },
        ],
      },
      {
        header: 'I. Hubungi Kami',
        content: [
          {
            content: (
              <p className="pl-5 text-justify leading-8">
                Jika Anda memiliki pertanyaan, keluhan, atau klaim mengenai
                Kebijakan Privasi ini, Anda dapat menghubungi tim customer
                service Kami melalui fitur chat di Platform atau kanal
                komunikasi resmi Kami lainnya.
              </p>
            ),
          },
        ],
      },
    ],
    agreement_statement_title: 'Pernyataan Persetujuan:',
    agreement_statement: `SAYA TELAH MEMBACA DAN MENGERTI SELURUH KETENTUAN DALAM KEBIJAKAN PRIVASI INI DAN KONSEKUENSINYA. DENGAN INI, SAYA MENERIMA SETIAP HAK, KEWAJIBAN, DAN KETENTUAN YANG TELAH DIATUR DALAM KEBIJAKAN PRIVASI INI. PERNYATAAN INI DIANGGAP SEBAGAI PERSETUJUAN SAYA SEBAGAI PEMILIK DAN/ATAU WALI DATA PRIBADI.`,
  },
];
